import { Button } from '@insify/design-system/components';
import { IconicChevronLeft } from '@insify/design-system/iconic-icons';
import { LogoWithTextInverted } from '@insify/design-system/logo';
import { TrackedAnchor } from '@objectiv/tracker-react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { LanguageSelect } from '../../../components/LanguageSelect';

import * as styles from './AuthLayout.module.css';

const BackButton = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const location = useLocation();
  if (!['/forgot-email'].includes(location.pathname)) {
    return null;
  }

  return (
    <Button
      className={styles.backButton}
      leftIcon={<IconicChevronLeft />}
      kind='tertiary'
      onClick={() => navigate(-1)}
      trackingId='back'
      href='#'
    >
      {t('back')}
    </Button>
  );
};

type Props = {
  children: React.ReactNode;
};

const AuthLayout: React.FC<Props> = ({ children }) => {
  const { t } = useTranslation('common');

  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <TrackedAnchor className={styles.logo} objectiv={{ id: 'logo' }} href='/'>
          <LogoWithTextInverted />
        </TrackedAnchor>
      </div>
      <div className={styles.backdrop}>
        <div className={styles.bannerContent}>
          <div className={styles.bannerText}>{t('banner_slogan')}</div>
        </div>
        <div className={styles.overlay} />
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.languageSelector}>
          <LanguageSelect />
        </div>
        <div className={styles.content}>
          <BackButton />
          <div className={styles.form}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export { AuthLayout };
